<template>
    <main class="verify-container" v-if="result">
        <h1>{{translate('user_verification_step_header')}}</h1>
        <transition name="fade" mode="out-in">
            <template v-if="verified">
                <h3>{{translate('user_verification_succeeded')}}</h3>
            </template>
            <template v-if="!verified">
                <h3>{{translate('user_verification_failed')}}</h3>
            </template>
        </transition>
        <svg v-if="verified" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
            <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
            <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
        </svg>
        <svg v-else version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
            <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
            <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3"/>
            <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2"/>
        </svg>
        <router-link v-if="verified" to="/login" class="register-link">
            <span class="text">{{translate('login')}}</span>
        </router-link>
    </main>
</template>

<script>
    export default {
        name: "Login",
        data() {
            return {
                result: false,
                verified: false
            }
        },
        methods: {
            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;

            },
        },
        created() {
            let tmp = '';
            let result = '';
            window.location.search
                .substr(1)
                .split("&")
                .forEach(function (item) {
                    tmp = item.split("=");
                    if (tmp[0] === 'hash') result = decodeURIComponent(tmp[1]);
                });
            let formData = new FormData();
            formData.append('hash', result);
            this.$apiController.verifyUser(formData)
                .then((res) => {
                    if (res.data === true) {
                        this.verified = true;
                    } else if (res.data === 'no_token_registered') {
                        this.verified = false;
                    } else if (res.data === 'token_already_verified') {
                        this.verified = true;
                        this.$notifications.add(this.$notifications.TYPES.WARNING,this.translate('notification_error'),this.translate('user_verification_duplicate'))
                    }
                })
            .finally(()=>{
                this.result = true;
            });
        }
    }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: all 0.3s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>
